<template>
  <div id="app">
    <Generator />
  </div>
</template>

<script>
import Vue from 'vue';
import Generator from './components/Generator.vue';
import Buefy from 'buefy';

Vue.use(Buefy);

export default {
  name: 'app',
  components: {
    Generator
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 60px;
  color: #2c3e50;
}

@import "~bulma/sass/utilities/_all";

$primary: #f66035;
$primary-invert: findColorInvert($primary);

$colors: (
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  )
);

$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
